import { BaseJs } from '@gate31/core/src/libs/BaseJsComponents';
import { CustomCn } from '@gate31/core/src/libs/classname';
import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import EventBus from 'EventBus';
import Products from 'Products';
import { Modal, ModalOpts } from '../Modal/Modal';

export class CardModalForm extends BaseJs {
    private cn: CustomCn;
    template: keyof LiquidTemplates;
    modalTemplate: ModalOpts['template'];
    whenOpenModal?: (product: unknown) => void

    modal: Modal

    constructor(options: {
        template: keyof LiquidTemplates;
        modalTemplate: ModalOpts['template'];
        cn: CustomCn;
        whenOpenModal?: (product: unknown) => void;
    }) {
        super(options.template);
        this.cn = options.cn;
        this.template = options.template;
        this.modalTemplate = options.modalTemplate;
        this.whenOpenModal = options.whenOpenModal;

        Products.setConfig({
            options: {
                default: 'option-radio',
                Размер: 'option-radio'
            },
            initOption: false,
            decimal: 0
        });

        EventBus.subscribe('add_items:insales:cart', (data) => {
            if (! data.action.form) {
                return;
            }

            this.modal.close();
        });

        document.addEventListener('click', e => {
            const target = e.target as HTMLElement;
            const button = target.closest('.JsTrigger_CardModalForm');

            if (button) {
                const product = JSON.parse(button.getAttribute('data-product') as string);

                this.showModal({
                    product,
                    whenOpenModal: async () => {
                        await Products.get(product.id); // Хак благодаря которому корректно погрудаются опции продукта

                        this.whenOpenModal?.(product);
                    }
                });
            }
        });
    }

    getModalContent(product: unknown): string {
        return LiquidRender.render(this.template, {
            product
        });
    }

    showModal(options: { product: unknown; whenOpenModal?: () => void }) {
        this.modal = new Modal({
            template: this.modalTemplate,
            content: this.getModalContent(options.product),
            disableBodyScroll: false,
            viewOpts: {
                closeIconSize: 'm',
                className: this.cn.toString()
            }
        });

        this.modal.open(options.whenOpenModal);
    }
}
